import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { otpValidation } from '../models/otpValidation.model';
import { getLocaleDateFormat } from '@angular/common';
import { UtilitiesService } from '../utilities/utilities.service';
//import { AnyMxRecord, AnyTxtRecord } from 'dns';
import { map } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
const httpOptionsForAutoSuggest = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' , 'ignoreLoadingBar' : ''})
};
@Injectable({ providedIn: 'root' })
export class ProductService {
  RECOMMENDED_ADDON_RESPONSE: any;
  RECOMMENDED_ACCONT_TYPE: string;
  RECOMMENDED_ADDON_RATE_PLAN: string;
  RECOMMENDED_ACCOUNT_NO: string;
  constructor(private http: HttpClient, private UTS: UtilitiesService) {}

  getCMSContent(U: string, M: string): Observable<any> {
    const cmscontentURLobj = { url: U, method: M };
    return this.http.post(
      `${environment.ECARE_URL}/getEshopHTML.service`,
      cmscontentURLobj,
      httpOptions
    );
  }

  getLibs(U: string, M: string): Observable<any> {
    const cmscontentURLobj = { url: U, method: M };
    return this.http.post(
      `${environment.ECARE_URL}/getLibs.service`,
      cmscontentURLobj,
      httpOptions
    );
  }

  getProductsByCategory(
    L: string,
    iADF: number = 1,
    C: string, //categoryId
    NS: string, //navigationState
    N: string = '0', //index number,
    rateplanCode?: string,
    T?: string
  ): Observable<any> {
    const type = (T) ? T : "Addon";
    const payload = { categoryId: C, navigationState: NS, No: N, type: type };
    const currentAccount = (localStorage.getItem('currentAccount')) ? JSON.parse(localStorage.getItem('currentAccount')) : null;
    if (currentAccount) {
      return this.http.post(
        `${environment.ECARE_URL
        }/getShopForMoreHybrid.service?locale=${L}&rateplanCode=${
          rateplanCode ? rateplanCode : ''
        }
        `,
        payload,
        httpOptions
      );
    } else {
      return this.http.post(
        `${
          environment.BASE_URL
        }/getProductsByCategory?locale=${L}&isApplyDefaultFilters=${
          iADF == 1 ? true : false
        }`,
        payload,
        httpOptions
      );
    }
  }

  getMobileEligibility(accountNo: number): Observable<any> {
    const payload = { accountNumber: accountNo };
    return this.http.post(
      `${environment.ECARE_URL}/getAccountType.service`,
      payload,
      httpOptions
    );
  }

  accountTypeValidation(accountNo: number): Observable<any> {
    const payload = {
      accountNo: accountNo,
      accountType: 'postpaid',
      isAccountId: false,
    };
    return this.http.post(
      `${environment.ECARE_URL}/accountTypeValidation.service`,
      payload,
      httpOptions
    );
  }

  generateOTP(accountNo: number): Observable<any> {
    const payload = {
      accountNo: accountNo,
      notificationType: 'SMS',
      notificationValue: accountNo,
      category: 'addon'
    };
    return this.http.post(
      `${environment.BASE_URL}/generateOtpByAccountNumber`,
      payload,
      httpOptions
    );
  }

  validateOTP(otpValidation: otpValidation): Observable<any> {
    if(otpValidation)
      otpValidation['category'] = "addon";
    return this.http.post(
      `${environment.BASE_URL}/validateOtpAccountNumber`,
      otpValidation,
      httpOptions
    );
  }

  getAccountType(accountNumber: string): Observable<any> {
    const payload = { accountNumber: accountNumber };
    return this.http.post(
      `${environment.ECARE_URL}/getAccountType.service`,
      payload,
      httpOptions
    );
  }

  getCountries(sku: string): Observable<any> {
    return this.http.get(
      `${environment.ESHOP_URL}/getCountries/${sku}`,
      httpOptions
    );
  }

  getAccountSummary(accountNo: string) {
    const payload = { accountNumber: accountNo };
    return this.http.post(
      `${environment.ECARE_URL}/getAccSummary.service`,
      payload,
      httpOptions
    );
  }
  public getRecommendedAddons(
    accountNo: string,
    addonRateplans: string,
    accountType: string
  ): Observable<any> {
    if (
      this.RECOMMENDED_ADDON_RESPONSE &&
      this.RECOMMENDED_ACCONT_TYPE == accountType &&
      this.RECOMMENDED_ADDON_RATE_PLAN == addonRateplans &&
      this.RECOMMENDED_ACCOUNT_NO == accountNo
    )
      return this.convertObjectInObservable(this.RECOMMENDED_ADDON_RESPONSE);
    return this.getRecommendedAddonsAPI(accountNo, addonRateplans, accountType);
  }
  getRecommendedAddonsAPI(
    accountNo: string,
    addonRateplans: string,
    accountType: string
  ) {
    const payload = {
      accountType: accountType,
      addonRateplans: addonRateplans ? addonRateplans : '',
      accountNumber: accountNo,
    };
    return this.http
      .post(
        `${environment.BASE_URL}/getRecommendedAddons.service`,
        payload,
        httpOptions
      )
      .pipe(
        map((R: any) => {
          this.RECOMMENDED_ACCONT_TYPE = accountType;
          this.RECOMMENDED_ADDON_RATE_PLAN = addonRateplans;
          this.RECOMMENDED_ACCOUNT_NO = accountNo;
          this.RECOMMENDED_ADDON_RESPONSE = R;
          return R;
        })
      );
  }
  getRoamingCountries(id)
  {
  //  http://localhost:8080/b2c/eshop/getRoamingCountries/0092
    return this.http.get(
      `${environment.BASE_URL}/getRoamingCountries/${id}`,
       httpOptions
    );

  }
  getRoamingCountriesList(id)
  {
    return this.http.get(
      `${environment.BASE_URL}/getRoamingCountriesList/${id}`,
       httpOptions
    );

  }
  getAddons_Stub(request: any) : Observable<any> {
    return this.http.get("./assets/stubs/addon.json");
  }

  getSkuByCountryName_Stub(advanceSearch , iADF, L) : Observable<any> {
    return this.http.get("./assets/stubs/productByCategory.json");
  }
  getSkuByCountryName(advanceSearch , iADF, L): Observable<any> {
    // let advanceSearchObject = Object.assign({}, advanceSearch);
    let advanceSearchObject=advanceSearch;

    return this.http.post(
      `${environment.BASE_URL
      }/getProductsByCategory?locale=${L}&isApplyDefaultFilters=${iADF == 1 ? true : false
      }`,
      advanceSearch,
      httpOptions
    );

   }

  getSuggestions (advanceSearch : any): Observable<any> {
    // let advanceSearchObject = Object.assign({}, advanceSearch);
    let advanceSearchObject=advanceSearch;

     return this.http
       .post<any>(environment.B2C_URL + "/guidedSearchRequest.service",advanceSearchObject, httpOptions);

   }

   getProratedDetails(skuId) {
    const lang = this.UTS.getLocaleLanguage();
    return this.http.get(
      `${environment.BASE_URL}/skus/proratedDetails/${skuId}?language=${lang}&productType=addon`,
       httpOptions
    );
  }

  private convertObjectInObservable(D: any): Observable<any> {
    const OBS = new Observable<any>((O) => {
      O.next(D);
      O.complete();
    });
    return OBS;
  }

  getRecieptDetails(id): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL}/getEreceiptDetails?transactionId=${id}`,
      httpOptions
    );
  }

  getGamingUserName(accountNumber: string): Observable<any> {
    return this.http.get(
      `${environment.BASE_URL}/getGamingUserName?accountNumber=${accountNumber}`,httpOptions);
  }

  validateGamingUser(payload: string): Observable<any> {
    return this.http.post(
      `${environment.ECARE_URL}/validateGamingUser.service`,payload,httpOptions);
  }

  getCategories(cat: string): Observable<any> {
    return this.http.get(
      `${environment.BASE_URL}/categories/${cat}`,httpOptions);
  }
  getSkuDetails(skuId): any {
    return this.http
    .get(environment.BASE_URL + `/getMultipleSkusDetails/${skuId}`,httpOptions).pipe(
        map((R: any) => {
          return R;
        })
      );
  }
  
  addCartMultiple(addedCommerceItem:any) {
    return this.http.post(`${environment.BASE_URL}/addToShoppingCartMultiple`,addedCommerceItem,httpOptions);
  };

  getRoamingSearchOnCountriesFilter(advanceSearch, L): Observable<any> {
    return this.http.post(
      `${environment.BASE_URL
      }/getProductsByCategory?locale=${L}&isApplyDefaultFilters=true`,
      advanceSearch,
      httpOptions
    );
  }

  generateOTPLogedInUser(accountNo: any, notificationValue:any): Observable<any> {
    const payload = {
      accountNo: accountNo,
      notificationType: 'SMS',
      notificationValue: notificationValue,
      category: 'addon'
    };
    return this.http.post(
      `${environment.BASE_URL}/generateOtpByAccountNumber`,
      payload,
      httpOptions
    );
  }
 }
